





















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import NavBar from "@/components/NavBar/NavBar.vue";
import AndroidBack, { POP_UP } from "@/utils/android_back";
@Component({
  components: { NavBar }
})
export default class Propup extends Vue {
  @Prop({ default: "slidedown" }) // slideup
  private transtionName?: string;
  @Prop()
  private value?: boolean;
  @Prop()
  private innerStyle?: string;

  private closePropup() {
    this.$emit("input", false);
    this.$emit("closePropup");
    AndroidBack.destroy(POP_UP);
  }

  @Watch("value", { immediate: false })
  private changePop(val: boolean, oldVal: boolean) {
    if (val) {
      AndroidBack.listen({
        key: POP_UP,
        fn: () => {
          this.closePropup();
        }
      });
    }
  }
}
